<template>
    <div class="enrich-contact-wrapper">
        <div class="action-modal-wrapper catchlight-enrichment-modal" v-if="showModal">
            <div class="action-modal-container">
                <div class="m-body">
                    <div class="import-contacts-header">
                        <h2>Enrich your contact to help find your best leads</h2>
                    </div>

                    <div class="col-sm-12 text-center">
                        <svg width="244" height="167" viewBox="0 0 244 167" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_ddddd_5347_2899)">
                                <rect x="99.375" y="6" width="123" height="123" rx="61.5" fill="white"
                                      shape-rendering="crispEdges"/>
                                <g clip-path="url(#clip0_5347_2899)">
                                    <path
                                        d="M150.485 77.8032C144.016 82.3925 135.518 84.0893 127.602 83.434C132.13 85.47 137.23 86.6566 142.236 86.5887C150.159 86.4787 152.049 85.2828 150.485 77.8032Z"
                                        fill="#991B1E"/>
                                    <path
                                        d="M175.1 78.5333C179.455 82.327 187.583 81.8027 192.968 81.7208C190.791 83.4316 188.241 84.3256 185.552 85.0768C184.224 85.4466 176.963 87.2954 175.977 86.5793C174.639 85.6081 175.01 79.7246 175.1 78.531V78.5333Z"
                                        fill="#991B1E"/>
                                    <path
                                        d="M125.641 102.735C133.148 101.466 140.133 97.2769 144.995 91.6953C151.686 84.0121 150.059 78.6341 144.978 70.3261C137.274 57.7306 134.843 42.0061 150.683 34.578C164.284 28.1983 184.264 35.4556 184.976 51.0631C185.421 60.8408 178.039 69.0295 178.348 78.4726C178.633 87.1996 188.778 96.0413 196.107 99.643C181.592 103.444 169.043 88.1849 162.808 77.9695C162.579 95.3134 139.865 101.436 125.641 102.739L125.641 102.735Z"
                                        fill="#EF3B39"/>
                                    <path
                                        d="M142.793 49.6283C142.793 49.6283 166.756 42.8204 194.26 43.822C194.26 43.822 197.332 58.6361 192.775 59.0387C192.775 59.0387 185.472 60.7915 177.58 60.4405C177.58 60.4405 174.297 61.3907 174.202 47.962L169.881 48.2288C169.881 48.2288 173.449 60.265 169.033 61.2432C169.033 61.2432 158.214 63.8456 148.627 63.8456C148.627 63.8456 145.007 64.3956 142.793 49.6307V49.6283Z"
                                        fill="#1B1D21"/>
                                    <path
                                        d="M191.593 48.1304L182.812 57.0112L184.225 58.3007L193.006 49.4199L191.593 48.1304Z"
                                        fill="white"/>
                                    <path
                                        d="M187.433 47.1615L181.426 53.2375L182.839 54.527L188.846 48.451L187.433 47.1615Z"
                                        fill="white"/>
                                </g>
                            </g>
                            <g filter="url(#filter1_ddddd_5347_2899)">
                                <rect x="22.5" y="21.375" width="92.25" height="92.25" rx="46.125" fill="#F26A22"/>
                                <g clip-path="url(#clip1_5347_2899)">
                                    <path
                                        d="M69.0352 41.1912V56.1971H72.6561V74.5638H79.4468V78.2944H69.0352V93.0611H94.4131V41.1912H69.0352Z"
                                        fill="white"/>
                                    <path
                                        d="M58.5578 55.8931C54.4553 55.8931 51.5781 57.8498 51.5781 63.2995V71.1935C51.5781 76.6432 54.4553 78.606 58.5578 78.606C62.6603 78.606 65.5375 76.6432 65.5375 71.1935V70.2792H61.3131V71.7483C61.3131 74.1866 60.2403 74.8693 58.5578 74.8693C56.8754 74.8693 55.8025 74.1927 55.8025 71.7483V62.7448C55.8025 60.3064 56.8754 59.6237 58.5578 59.6237C60.2403 59.6237 61.3131 60.3003 61.3131 62.7448V63.3543H65.5375V63.2934C65.5375 57.8681 62.6603 55.8931 58.5578 55.8931Z"
                                        fill="white"/>
                                </g>
                            </g>
                            <defs>
                                <filter id="filter0_ddddd_5347_2899" x="77.7539" y="0.522657" width="166.242"
                                        height="166.242" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feMorphology radius="1.28125" operator="dilate" in="SourceAlpha"
                                                  result="effect1_dropShadow_5347_2899"/>
                                    <feOffset/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix"
                                                   values="0 0 0 0 0.105882 0 0 0 0 0.113725 0 0 0 0 0.129412 0 0 0 0.04 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                             result="effect1_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="1.68164"/>
                                    <feGaussianBlur stdDeviation="1.80176"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                                    <feBlend mode="normal" in2="effect1_dropShadow_5347_2899"
                                             result="effect2_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="6.72656"/>
                                    <feGaussianBlur stdDeviation="3.36328"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
                                    <feBlend mode="normal" in2="effect2_dropShadow_5347_2899"
                                             result="effect3_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="15.1348"/>
                                    <feGaussianBlur stdDeviation="4.56445"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"/>
                                    <feBlend mode="normal" in2="effect3_dropShadow_5347_2899"
                                             result="effect4_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="16.1438"/>
                                    <feGaussianBlur stdDeviation="10.8105"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                    <feBlend mode="normal" in2="effect4_dropShadow_5347_2899"
                                             result="effect5_dropShadow_5347_2899"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect5_dropShadow_5347_2899"
                                             result="shape"/>
                                </filter>
                                <filter id="filter1_ddddd_5347_2899" x="0.878906" y="15.8977" width="135.492"
                                        height="135.492" filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feMorphology radius="1.28125" operator="dilate" in="SourceAlpha"
                                                  result="effect1_dropShadow_5347_2899"/>
                                    <feOffset/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix"
                                                   values="0 0 0 0 0.105882 0 0 0 0 0.113725 0 0 0 0 0.129412 0 0 0 0.04 0"/>
                                    <feBlend mode="normal" in2="BackgroundImageFix"
                                             result="effect1_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="1.68164"/>
                                    <feGaussianBlur stdDeviation="1.80176"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"/>
                                    <feBlend mode="normal" in2="effect1_dropShadow_5347_2899"
                                             result="effect2_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="6.72656"/>
                                    <feGaussianBlur stdDeviation="3.36328"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"/>
                                    <feBlend mode="normal" in2="effect2_dropShadow_5347_2899"
                                             result="effect3_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="15.1348"/>
                                    <feGaussianBlur stdDeviation="4.56445"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"/>
                                    <feBlend mode="normal" in2="effect3_dropShadow_5347_2899"
                                             result="effect4_dropShadow_5347_2899"/>
                                    <feColorMatrix in="SourceAlpha" type="matrix"
                                                   values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                                   result="hardAlpha"/>
                                    <feOffset dy="16.1438"/>
                                    <feGaussianBlur stdDeviation="10.8105"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"/>
                                    <feBlend mode="normal" in2="effect4_dropShadow_5347_2899"
                                             result="effect5_dropShadow_5347_2899"/>
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect5_dropShadow_5347_2899"
                                             result="shape"/>
                                </filter>
                                <clipPath id="clip0_5347_2899">
                                    <rect width="70.4688" height="70.4688" fill="white"
                                          transform="translate(125.641 32.2656)"/>
                                </clipPath>
                                <clipPath id="clip1_5347_2899">
                                    <rect width="50.3591" height="50.3591" fill="white"
                                          transform="translate(43.4453 42.3203)"/>
                                </clipPath>
                            </defs>
                        </svg>

                        <button class="btn btn-danger btn-lg modal-action-button warning"
                                @click="$emit('enrich-contact')">Enrich now
                        </button>

                        <p class="enrich-contact-text">
                            <strong>This will be a one-time enrichment of this contact. Contact enrichment will be subject to fees in accordance with your agreement with Catchlight. By clicking “Enrich now”, you acknowledge you have read and agree to Catchlight’s
                              <a href='https://catchlight.ai/terms-of-use' target='_blank'>Terms of Use</a> and
                              <a href='https://catchlight.ai/privacy' target='_blank'>Privacy Policy</a>
                            </strong>
                        </p>

                        <p class="enrich-contact-text"> Catchlight sends data to Snappy Kraken, which includes a predictive score on the likelihood that a lead
                          will convert. With an enriched contacts list, advisors can prioritize outreach and use insights to help
                          deliver the optimal message.</p>
                    </div>
                </div>

                <div class="close-modal" @click="closeModal()">x</div>
            </div>
        </div>

        <button type="button" class="btn btn-lg btn-warning" @click="handleShowModal()"
                v-tooltip="'Use Catchlight to see this contact\'s investable assets, income, projected value, and more'">
            Enrich with Catchlight
        </button>
    </div>
</template>

<script>
import VTooltip from 'v-tooltip';

export default {
    name: 'enrich-contact',
    components: {VTooltip},
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
        handleShowModal() {
            this.showModal = true;
            this.$emit('get-catchlight');
        },

        closeModal() {
            this.showModal = false;
        },

        onCloseModal() {
            this.closeModal();
        },
    },
    props: {
        contact: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss">
.enrich-contact-wrapper {
    display: inline;
}

.enrich-contact-text {
    margin-bottom: 15px;
    font-size: 21px;
    font-weight: 200;
}

.catchlight-enrichment-modal {

    .action-modal-container {
        padding-top: 30px;
    }

    h2 {
        font-size: 1.4em;
        margin-bottom: 0;
    }

    img {
        width: 740px;
        margin: auto;
    }

    button {
        margin-top: 0;
        margin-bottom: 30px;
    }
}
</style>
